import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { addDocumentId } from "../../Redux/store/documentSlice";
import { debounce } from "lodash";
import { useToast } from "../../Utils/toastContext";
import { useNavigate, useLocation } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const AddDocumentPopup = ({
  isOpen,
  onClose,
  setfilterData,
  data,
  IsUpdate,
  investment_id,
}) => {
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const navigate = useNavigate();

  const [file, setFile] = useState(null);
  const [newFileData, setnewFileData] = useState([]);
  const [resetAllow, setresetAllow] = useState(true);
  const [fromEdit, setfromEdit] = useState(false);
  const [clickOne, setclickOne] = useState(false);
  const [loading, setLoading] = useState(false);

  const [documentId, setdocumentId] = useState(null);
  const [documentuniqueId, setdocumentuniqueId] = useState(null);
  const [documentName, setdocumentName] = useState(null);

  const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert string to Date object
    const day = String(date.getDate()).padStart(2, "0"); // Get day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed) with leading zero
    const year = date.getFullYear(); // Get full year

    return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
  };
  const formatDateExisting = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  const [dateAdded, setdateAdded] = useState(formatDate(new Date()));

  useEffect(() => {
    if (data?.date_uploaded) {
      setdocumentId(data.document_id);
      setdocumentuniqueId(data.unique_id);
      setdocumentName(data.document_name);
      setdateAdded(formatDateExisting(data.date_uploaded));
      setresetAllow(false);
      setfromEdit(true);
    }
  }, [data, isOpen]);

  const fileUpdate = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/document/update/${documentId}`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    formData3.append("document_id", documentId); // Append additional data
    formData3.append("name", documentName);
    let f = formData3.get("file");
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const fileUpload = async (file) => {
    setclickOne(true);
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/document/upload`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    formData3.append("document_id", "12345"); // Append additional data
    formData3.append("name", documentName);
    let f = formData3.get("file");
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const fileUploadNew = async (file) => {
    setclickOne(true);
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/document/investment-portfolio/${investment_id}`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    formData3.append("document_id", "12345"); // Append additional data
    formData3.append("name", documentName);
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleUploadFile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        if (IsUpdate == true) {
          const response = await fileUploadNew(file);
          if (response.status == 201) {
            console.log("done");
            console.log("Uploaded File:", file);
            setnewFileData([...newFileData, response.data]);
            // setfilterData([...newFileData, response.data]);
            dispatch(addDocumentId(response.data.document_id));
            setnewFileData([...newFileData, response.data]);
            //setfilterData([...newFileData, response.data]);
            setdocumentId(null);
            setdocumentName(null);
            setdateAdded(formatDate(new Date().toISOString().split("T")[0]));
            setFile(null);
            setclickOne(false);
            onClose();
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } else {
          const response = await fileUpload(file);
          if (response.status == 201) {
            console.log("done");
            console.log("Uploaded File:", file);
            setnewFileData([...newFileData, response.data]);
            // setfilterData([...newFileData, response.data]);
            dispatch(addDocumentId(response.data.document_id));
            setnewFileData([...newFileData, response.data]);
            // setfilterData([...newFileData, response.data]);
            setdocumentId(null);
            setdocumentName(null);
            setdateAdded(formatDate(new Date().toISOString().split("T")[0]));
            setFile(null);
            setclickOne(false);
            onClose();
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [file, documentName] // Dependencies
  );
  const handleUpdateFile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await fileUpdate(file);
        if (response.status == 200) {
          console.log("done");
          console.log("Uploaded File:", file);
          setnewFileData([...newFileData, response.data]);
          setfilterData([...newFileData, response.data]);
          setdocumentId(null);
          setdocumentuniqueId(null);
          setdocumentName(null);
          setdateAdded(formatDate(new Date().toISOString().split("T")[0]));
          setFile(null);
          onClose();
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [file, documentName] // Dependencies
  );
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFile(selectedFile);
      } else {
        alert("File must be PDF, PNG, or JPEG and less than 10MB.");
      }
    }
  };

  const handleDeleteFile = () => {
    setFile(null);
  };
  const handleReset = () => {
    setresetAllow(true);
    setFile(null);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="bg-white rounded-md shadow-lg p-6 w-[90%] max-w-3xl relative">
        {/* Popup Header */}
        <button
          onClick={() => {
            onClose();
          }}
          className="absolute top-4 rounded-full right-4 font-medium text-white bg-black px-2 py-1"
        >
          ✕
        </button>
        {!fromEdit && (
          <div className="text-center mb-6">
            <h2 className="text-lg font-medium">
              Add Document<span className="text-[#8C8C8C]"> : DXXXX</span>
            </h2>
          </div>
        )}
        {fromEdit && (
          <div className="text-center mb-6">
            <h2 className="text-lg font-medium">
              Update Document
              <span className="text-[#8C8C8C]"> : {data.unique_id}</span>
            </h2>
          </div>
        )}
        {/* Main Grid with Left and Right Sections */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Left Section - Document Information */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Document ID
            </label>
            <input
              type="text"
              name="documentId"
              value={documentuniqueId}
              disabled
              className="w-full rounded-xl px-3 py-2 mb-4"
              placeholder="DXXXX"
            />

            <label className="block text-sm font-medium mb-2">
              Document Name
            </label>
            <input
              type="text"
              name="documentName"
              value={documentName}
              onChange={(e) => setdocumentName(e.target.value)}
              disabled={!resetAllow}
              className="w-full rounded-xl px-3 py-2 mb-4"
              placeholder="Enter Document Name"
            />

            <label className="block text-sm font-medium mb-2">Date Added</label>
            <input
              type="text"
              name="dateAdded"
              value={dateAdded}
              disabled={true}
              onChange={handleInputChange}
              className="w-full rounded-xl px-3 py-2"
            />
          </div>

          {/* Right Section - Upload Document */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Upload Document
            </label>

            {/* Drag & Drop Upload Area */}
            <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
              <input
                type="file"
                id="fileUpload"
                accept=".pdf,.png,.jpeg"
                disabled={!resetAllow}
                onChange={handleFileChange}
                className="hidden"
              />
              <img
                src="/folder-add.svg"
                alt="Success Icon"
                className="h-4 w-4"
              />{" "}
              <p className="mt-2 text-gray-500 text-sm">
                Drag & Drop <br />
                or Click to Upload
              </p>
            </label>
            <div className="mt-1">
              <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                PNG
              </span>
              <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                JPEG
              </span>
              <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                PDF
              </span>
              <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                &#60; 10 MB
              </span>
            </div>
            {/* Display Uploaded File Information */}
            {resetAllow && (
              <div>
                {file && (
                  <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                    <span className="text-black">
                      {file ? file.name : data.document_name}
                    </span>
                    <button
                      onClick={handleDeleteFile}
                      className="text-red-500 flex-shrink-0 font-semibold"
                    >
                      <img
                        src="/trash.svg"
                        alt="Success Icon"
                        className="h-4 w-4 flex-shrink-0"
                      />
                    </button>
                  </div>
                )}
              </div>
            )}

            {!resetAllow && (
              <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                <span className="text-black">{data.file_name}</span>{" "}
              </div>
            )}
          </div>
        </div>

        {/* Actions */}
        {!fromEdit && (
          <div className="flex justify-center mt-6">
            <button
              onClick={(e) => {
                e.preventDefault();
                if (!file) {
                  showToast("Please Add a file", "error");
                  return;
                }
                if (!documentName) {
                  showToast("Please Add a document name", "error");
                  return;
                }
                setLoading(true);
                handleUploadFile(e);
              }}
              disabled={clickOne == true ? true : false}
              className="px-10 py-2 bg-black text-white rounded-full text-sm"
            >
              Save
            </button>
          </div>
        )}
        {fromEdit && (
          <div className="flex justify-center mt-6">
            <button
              onClick={handleReset}
              className="px-10 py-2 bg-white text-black mr-4 border-black border rounded-full text-sm"
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                if (!file) {
                  showToast("Please Add a file", "error");
                  return;
                }
                if (!documentName) {
                  showToast("Please Add a document name", "error");
                  return;
                }
                setLoading(true);
                handleUpdateFile(e);
              }}
              disabled={!resetAllow}
              className="px-10 py-2 bg-black text-white rounded-full text-sm"
            >
              Save
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddDocumentPopup;
